import styled from 'styled-components';
import { Button, Modal } from 'antd';

export const StoreSelectContainer = styled.div`
  button {
    width: 100%;
  }
  .ant-space {
    display: flex;
  }
`;

export const SidebarPolicyLinks = styled.div.attrs({
  className: 'sidebar-policy-links'
})`
  margin: 20px auto;
  padding: 0 20px;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;

  a {
    color: #6d7582;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: #1890ff;
    }

    strong {
      font-weight: 700;
    }
  }

  span {
    color: #6d7582;
    text-decoration: none;
    transition: color 0.3s;
  }

  .divider {
    margin: 0 8px;
    color: #d9d9d9;
  }
`;

export const ISMSPolicy = styled.div.attrs({
  className: 'isms-policy'
})`
  margin: 20px auto;
  padding: 0 20px;
  text-align: start;
  font-size: 14px;
  line-height: 1.5;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  a {
    color: #6d7582;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: #1890ff;
    }

    strong {
      font-weight: 700;
    }
  }

  span {
    color: #6d7582;
    text-decoration: none;
    transition: color 0.3s;
  }

  .divider {
    margin: 0 8px;
    color: #d9d9d9;
  }
`;

export const AdmissionButton = styled(Button)`
  border-color: ${({ theme }) => theme.color.gray01};
  background-color: ${({ theme }) => theme.color.gray01};
  color: ${({ theme }) => theme.color.white};
  &:hover,
  :active,
  :focus {
    border-color: ${({ theme }) => theme.color.black};
    background-color: ${({ theme }) => theme.color.black};
    color: ${({ theme }) => theme.color.white};
  }
`;

export const SettleModal = styled(Modal)`
  color: #353c49;
  .ant-modal-header .ant-modal-title {
    font-size: 22px;
    font-weight: 700;
  }
  .ant-modal-body {
    font-size: 16px;
    .bold {
      font-weight: 700;
    }
  }
  .ant-modal-footer .ant-btn-primary {
    width: 100px;
    border-radius: 4px;
  }
`;

export const SideBarCertTooltipContent = styled.div`
  position: absolute;
  bottom: 33px;
  left: 13%;
  width: 250px;
  background: #ffffff;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: #7f7f7f solid 1px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-contents: flex-start;
  align-items: start;
  font-size: 13px;
  font-weight: 400;
  :after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 12px 10px 0;
    border-color: #ffffff transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: -12px;
    left: 12px;
  }
  :before {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 12px 10px 0;
    border-color: #7f7f7f transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: -13px;
    left: 12px;
  }
`;
